import { render, staticRenderFns } from "./DistressalertsGrid.vue?vue&type=template&id=1f3781c6"
import script from "./DistressalertsGrid.vue?vue&type=script&lang=js"
export * from "./DistressalertsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports